var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletMoney(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_261_3770)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5712 17.9999V21.4285C20.5712 21.8831 20.3905 22.3192 20.0691 22.6406C19.7477 22.9621 19.3116 23.1428 18.8569 23.1428H2.57122C2.11656 23.1428 1.68053 22.9621 1.35904 22.6406C1.03755 22.3192 0.856934 21.8831 0.856934 21.4285V8.57132C0.856934 5.73101 3.15948 3.42847 5.99979 3.42847H17.1426V7.71418",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2854 12.8569H16.2854C15.812 12.8569 15.4282 13.2407 15.4282 13.7141V17.1426C15.4282 17.616 15.812 17.9998 16.2854 17.9998H22.2854C22.7587 17.9998 23.1425 17.616 23.1425 17.1426V13.7141C23.1425 13.2407 22.7587 12.8569 22.2854 12.8569Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5714 12.857V9.4284C20.5714 8.97373 20.3907 8.53771 20.0693 8.21621C19.7479 7.89473 19.3118 7.71411 18.8571 7.71411H17.1429H6",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_261_3770"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletMoney);
export default __webpack_public_path__ + "static/media/wallet-money.fab8494496a777bde1428bac4693749b.svg";
export { ForwardRef as ReactComponent };